import { render, staticRenderFns } from "./LogFilesView.vue?vue&type=template&id=612c6600"
import script from "./LogFilesView.vue?vue&type=script&lang=js"
export * from "./LogFilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports